import React from "react";
import { useForm } from "react-hook-form";
import { shareDataApi } from "../../../services/shareDataService";
import MainPageDialog from "../../../components/dialog";
import { shallowEqual, useSelector } from "react-redux";
import moment from "moment";
import { Loader } from "../../../components/loader/index";
import { toast } from "react-toastify";
import { DatePickerFeild } from "../../../components/reactHookFormFields/datePicker";

const ClinicalSummaryCCD = ({ shareDataDetail, selectedChat }) => {
  const { shareDataArr } = shareDataDetail;
  const [patientClinicalView, { isFetching: isLoading }] =
    shareDataApi?.endpoints?.patientClinicalView?.useLazyQuery();
  const { ...formHandler } = useForm();
  const onSubmit = (data) => {
    const obg = {
      type: "ccd",
      pid: selectedChat?.pid,
      portal: "provider",
      template: 1,
      form: data?.form && moment(data?.form).format("MM/DD/YYYY"),
      to: data?.to && moment(data?.to).format("MM/DD/YYYY"),
    };
    patientClinicalView(obg)?.then((res) => {
      if (res?.data?.response?.code == 0) {
        let tempData = { ...shareDataArr };
        tempData?.clinicalSummaryCCD?.selectedData?.push(res?.data);
        shareDataDetail?.setShareDataArr({ ...tempData });
        shareDataDetail?.closeDialog();
      } else {
        toast.error(res?.data?.response?.msg);
      }
    });
  };

  return (
    <MainPageDialog
      title="Generate CCD"
      footer={true}
      maxHeight={true}
      hideOverFlow={true}
      modalSize="md"
      onCancelHandler={() => shareDataDetail?.closeDialog()}
      footerList={[
        {
          title: "close",
          type: "cancel",
          action: () => {
            shareDataDetail?.closeDialog();
          },
        },
      ]}
    >
      {isLoading && (
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-[999]">
          <Loader />
        </div>
      )}
      <div className="m-5">
        <form
          onSubmit={formHandler?.handleSubmit(onSubmit)}
          className="flex items-center gap-5"
        >
          <div className="w-1/3 flex-1">
            <DatePickerFeild
              name="form"
              title="Start Date"
              control={formHandler?.control}
              dateTime={false}
              maxDate={new Date()}
            />
          </div>
          <div className="w-1/3 flex-1">
            <DatePickerFeild
              name="to"
              title="End Date"
              control={formHandler?.control}
              dateTime={false}
              maxDate={new Date()}
            />
          </div>
          <div className="">
            <button className="bg-teal1000 text-white px-4 py-2 rounded-md">
              Generate & Select{" "}
            </button>
          </div>
        </form>
      </div>
    </MainPageDialog>
  );
};

export default ClinicalSummaryCCD;
